<template>
  <div v-if="lot">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Nouvelle Dénonciation {{lot.ref}} {{lot.program_name}}
      </span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-8 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-border">
          <div class="columns is-multiline is-margin-top-small">
            <div class="column is-12 is-9-widescreen is-padding-bottom-xsmall">
              <label class="label">Lot</label>
              <div class="columns is-vcentered is-gapless is-margin-top-small">
                <div v-if="program && program.pictures" class="column is-narrow">
                  <avatar :item="program"></avatar>
                </div>
                <div class="column">
                  <b class="is-margin-left-xsmall">{{lot.ref}}</b> {{lot.program_name}}
                </div>
              </div>
            </div>
            <div class="column is-12 is-9-widescreen is-paddingless-bottom" v-if="(isAdmin || isSectorManager || isManager)">
              <div class="label">Cette dénonciation est-elle pour vous ?</div>
              <div class="is-margin-top-small is-margin-bottom-small">
                <input id="selfDenunciation" type="checkbox" name="selfDenunciation"
                       @change="seller === null"
                       class="switch is-success is-rounded is-medium is-success" v-model="selfDenunciation">
                <label for="selfDenunciation" class="label">
                  <span class="is-size-6 has-text-grey">{{selfDenunciation ? 'Oui' : 'Non'}}</span>
                </label>
              </div>
            </div>
            <div class="column is-12 is-9-widescreen is-paddingless-bottom" v-if="(isAdmin || isSectorManager || isManager) && !selfDenunciation">
              <label class="label">Choisir un vendeur</label>
              <div v-if="totalSellers !== null && totalSellers === 0"
                   class="column is-12 columns is-paddingless is-margin-top-small">
                <div class="column is-12 is-margin-bottom-xsmall is-paddingless">
                  <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                    <p>Vous n'avez pas d'utilisateur.</p>
                  </div>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-margin-top-small is-border is-padding-small bloc-add">
                <div class="column" v-if="!seller">
                  <div class="is-uppercase" @click.prevent.stop="openSellerSelectionQuickView">
                    <span class="picto">
                      <span class="is-border"><i class="fal fa-user-plus"></i></span>
                    </span>
                    <span>Choisir un vendeur</span>
                  </div>
                </div>
                <div v-if="seller" class="column columns is-gapless">
                  <div class="column is-9 is-vcentered columns">
                    <avatar :item="seller"></avatar>
                    <div class="is-margin-left-small">
                      <div class="title is-4"><b>{{seller.first_name}} {{seller.last_name}}</b></div>
                      <div class="subtitle">{{seller.profil_type|profilTypeLabel}}</div>
                    </div>
                  </div>
                  <div class="column is-3 has-text-right actions">
                    <button class="button is-circle" @click="seller = null; contact = null">
                      <i class="fal fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="has-bg-annonce columns is-vcentered" v-if="displayErrorMessage">
                <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
                  <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
                </div>
                <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
                  <div class="has-text-white is-italic is-size-6">
                    <span v-if="seller.disabled === true">Ce compte utilisateur est désactivé. Vous ne pourrez pas valider la pose de dénonciation.
                      <router-link :to="{name: 'UserVue', params: {id: seller.pk}}" class="has-text-white">Accéder à la fiche utilisateur.</router-link></span>
                    <span v-else-if="companyIsDisabled">La société de l'utilisateur est désactivée.</span>
                    <span v-else-if="!sellerHasAccess">La société de l'utilisateur n'a pas de mandat pour ce programme.
                      <!-- <router-link v-if='isAdmin' :to="{name: 'AccessCreate', query: accessQuery }" class="has-text-white is-underline">Créer un mandat</router-link> -->
                    </span>
                    <span v-else-if="!seller.last_login_at">Cet utilisateur ne s'est jamais connecté.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 is-9-widescreen is-paddingless-bottom is-margin-bottom-large">
              <label class="label">Contact</label>
              <div v-if="totalContact !== null && totalContact === 0 && (seller || selfDenunciation) && !contact"
                   class="column is-12 columns is-paddingless is-margin-top-small">
                <div class="column is-6 is-margin-bottom-xsmall is-paddingless">
                  <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                    <p>Ce vendeur ne possède pas de contact actuellement.</p>
                  </div>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-margin-top-small is-border" v-if="!contact">
                <div v-if="totalContact && totalContact > 0" class="column is-border-right is-6" :class="isDisabled">
                  <div class="is-padding-small is-uppercase"
                       @click.prevent.stop="openContactSelectionQuickView">
                    <span class="picto"><span class="is-border"><i
                      class="fal fa-list-ul"></i></span></span>
                    <span> Contact existant</span>
                  </div>
                </div>
                <div class="column" :class="isDisabled">
                  <div class="is-padding-small is-uppercase is-6"
                       @click.prevent.stop="openNewContactQuickView">
                    <span class="picto"><span class="is-border"><i
                      class="fal fa-user-plus"></i></span></span>
                    <span> Créer un contact</span>
                  </div>
                </div>
              </div>
              <div v-if="contact"
                   class="columns is-gapless is-padding-small is-margin-top-small is-multiline bloc-add">
                <div class="column is-12 columns is-gapless">
                  <div class="column is-1 columns">
                    <avatar :item="contact"></avatar>
                  </div>
                  <div class="column is-8 is-vcentered columns">
                    <div class="is-margin-left-small">
                      <div class="title is-4"><b>{{contact.first_name}} {{contact.last_name}}</b></div>
                      <div class="columns">
                        <div class="column is-paddingless is-5">
                          <span class="has-text-weight-medium is-size-6 has-text-grey-dark">Adresse : </span><br>
                          <span class="has-text-weight-medium is-size-6 has-text-grey-dark">Mail : </span><br>
                          <span class="has-text-weight-medium is-size-6 has-text-grey-dark">Téléphone : </span>
                        </div>
                        <div class="column is-paddingless is-narrow">
                          <span class="is-size-6 has-text-grey-dark">{{contact.address|prettyInlineAddress}}</span><br>
                          <span class="is-size-6 has-text-grey-dark">{{contact.email || 'NC'}}</span><br>
                          <span class="is-size-6 has-text-grey-dark" v-if="contact.phone">{{contact.phone|prettyPhone}}</span><span v-else>NC</span><br>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-3 has-text-right actions">
                    <button class="button is-circle" @click="contact = null">
                      <i class="fal fa-times"></i>
                    </button>
                  </div>
                </div>
                <div v-if="contact.spouse" class="column is-12 columns is-gapless">
                  <div class="column is-1 columns">
                    <avatar :item="contact.spouse_name"></avatar>
                  </div>
                  <div class="column is-8 is-vcentered columns">
                    <div class="is-margin-left-small">
                      <span class="has-text-weight-medium is-size-6 has-text-grey-dark">
                        INFORMATION : Le conjoint <b>"{{contact.spouse_name}}"</b> sera également dénoncé.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
              <div class="column is-6">
                <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                  <span>Annuler</span>
                </a>
              </div>
              <div class="column is-6">
                <button @click="submit" class="button is-success is-uppercase is-fullwidth has-text-white"
                        :disabled="!canSubmit || loading === true" :class="{'is-loading':loading}">
                  <span v-if="!loading">Valider</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="column is-4 is-3-widescreen">
        <div class="is-border is-radius-large" v-if="helperTitle || helperText">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 is-size-4">
              <b>Le saviez-vous ?</b>
            </div>
            <div class="column has-text-grey">
              <p><b>{{helperTitle}}</b></p>
              <p class="is-margin-top-small">{{helperText}}</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import { Error, DefaultValues } from '@/mixins'
  import { isNil } from 'lodash'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'DenunciationCreate',
    mixins: [Error, DefaultValues],
    data () {
      return {
        totalContact: null,
        selfDenunciation: true,
        seller: null,
        contact: null,
        lot: null,
        isLoadingContact: false,
        isLoadingLots: false,
        program: {},
        helperTitle: null,
        helperText: null,
        loading: false,
        totalSellers: null,
        sellerHasAccess: true,
        companyIsDisabled: false
      }
    },
    watch: {
      selfDenunciation (v) {
        this.contact = null
        this.seller = null
        if (this.isManager) {
          this.getSellersCount()
        }
        return this.getContactsCount()
      },
      seller (v) {
        this.sellerHasAccess = true
        this.companyIsDisabled = false
        if (v && v.is_external) {
          this.userHasAccess(true)
          this.getCompany(v.company)
        }
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            this.seller = results.entities[0]
            this.getContactsCount()
          } else if (mode === 'CONTACT_SELECTION') {
            this.contact = results.entities[0]
          } else if (mode === 'NEW_CONTACT') {
            this.submitContact(results.contact)
          }
        }
      }
    },
    computed: {
      ...mapState(['currentUser', 'quickview']),
      ...mapGetters(['currentUserPk', 'isSeller', 'isManager', 'isSectorManager', 'isAdmin', 'isExternal', 'isDistributeurMode']),
      lotPk () {
        return this.$route.query.lot
      },
      canSubmit () {
        return this.sellerHasAccess &&
                isNil(this.denunciation.buyer) === false &&
                isNil(this.denunciation.seller) === false &&
                (this.seller ? this.seller.disabled === false : true) &&
                !this.companyIsDisabled
      },
      excludedContactPk () {
        let tab = []
        if (this.contact) {
          tab.push(this.contact.pk)
        }
        if (this.lotDenunciations) {
          tab = tab.concat(this.lotDenunciations.map(x => x.buyer))
        }
        return tab
      },
      denunciation () {
        let seller = this.isSeller || this.selfDenunciation ? this.currentUserPk : this.seller
        return {
          seller: seller,
          buyer: this.contact,
          lot: this.lotPk
        }
      },
      currentSeller () {
        if (this.isSeller || this.selfDenunciation) {
          return this.currentUser
        } else if (this.seller) {
          return this.seller
        } else {
          return null
        }
      },
      sellerPk () {
        if (this.currentSeller) {
          return this.currentSeller.pk
        } else {
          return null
        }
      },
      isDisabled () {
        if (this.seller || this.selfDenunciation) return 'bloc-add'
        else return 'has-content-disabled has-text-grey'
      },
      displayErrorMessage () {
        return this.seller && (this.seller.disabled === true || !this.seller.last_login_at || !this.sellerHasAccess || this.companyIsDisabled === true)
      },
      accessQuery () {
        let query = {}
        if (this.program && this.program.pk) {
          query.program = this.program.pk
          if (this.program.promoteur && this.isDistributeurMode) {
            query.promoteur = this.program.promoteur.pk || this.program.promoteur
          }
        }
        if (this.seller && this.seller.company) {
          query.company = this.seller.company
        }
        return query
      }
    },
    methods: {
      openContactSelectionQuickView () {
        if (this.seller || this.selfDenunciation) {
          let params = {
            excludes: this.excludedContactPk,
            mode: 'store'
          }
          if (this.isSeller || this.selfDenunciation) {
            params.seller = this.currentUserPk
          } else {
            params.seller = this.seller.pk
          }
          this.$store.commit('setQuickview', {mode: 'CONTACT_SELECTION', params: params})
        }
      },
      openSellerSelectionQuickView () {
        let params = {}
        params.facets = {
          'USER': ['is_editor:False', 'is_operator:False']
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      openNewContactQuickView () {
        if (this.seller || this.selfDenunciation) {
          this.$store.commit('setQuickview', {mode: 'NEW_CONTACT', params: {}})
        }
      },
      getLot () {
        this.isLoadingLots = true
        this.$api.lotService.getOne(this.lotPk).then(res => {
          this.isLoadingLots = false
          this.lot = res.data
          if (this.isExternal) {
            this.userHasAccess()
          }
          this.getProgram(res.data.program)
        })
      },
      userHasAccess () {
        this.$api.userService.hasAccess(this.sellerPk, {lot: this.lot.pk}).then(r => {
          this.sellerHasAccess = !!r.data
        })
      },
      getProgram (id) {
        this.$api.programService.getOne(id).then(r => {
          this.program = r.data
        })
      },
      getCompany (company) {
        if (company && company.pk) {
          company = company.pk
        }
        this.$api.companyService.getOne(company).then(r => {
          this.companyIsDisabled = r.data.disabled
        })
      },
      submitContact (contact) {
        this.isLoadingContact = true
        contact.seller = this.denunciation.seller
        this.$api.contactService.post(contact)
          .then(res => {
            this.contact = res.data
            this.isLoadingContact = false
            this.$notify({
              type: 'is-success',
              text: 'Le contact a été créé.'
            })
          })
          .catch(err => {
            this.isLoadingContact = false
            this.handleError(err)
          })
      },
      submit () {
        this.loading = true
        this.$api.denunciationService.post(this.denunciation).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le contact a été dénoncé.'
          })
          this.$router.push({name: 'DenunciationList'})
        }).catch(err => {
          this.loading = false
          this.handleError(err)
        })
      },
      getContactsCount () {
        let query = {
          per_page: 1
        }
        if (this.denunciation.seller) {
          query.seller = this.sellerPk
        }
        this.$api.contactService.get(query)
          .then(r => {
            this.totalContact = r.data.total
          })
      },
      getHelper () {
        // this.$contentful.getEntry('5N66LwKL28CQQkOm4G4sg0').then(entry => {
        //   this.helperTitle = entry.fields.title
        //   this.helperText = entry.fields.text
        // })
      }
    },
    created () {
      this.getLot()
      this.getContactsCount()
      this.getHelper()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/denunciation/DenunciationCreate.vue